<template>
  <div class="common-seach-wrap">
    <!--基础设置-->
    <Card v-if="activeName=='card'"></Card>
    <!--分享设置-->
    <Category v-if="activeName=='category'"></Category>
    <Code v-if="activeName=='code'"></Code>
    <Order v-if="activeName=='order'"></Order>
    <Setting v-if="activeName=='setting'"></Setting>
  </div>
</template>
<script>
  import bus from '@/utils/eventBus.js';
  import Card from './card/index';
  import Category from './category/index';
  import Code from './code/index';
  import Order from './order/index';
  import Setting from './setting/index';
  export default {
    components: {
      Card,
      Category,
      Code,
      Order,
      Setting
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        form: {},
        /*参数*/
        param: {},
        /*当前选中*/
        activeName: 'card',
        /*切换数组原始数据*/
        sourceList: [
            {
                key: 'card',
                value: '卡券管理',
                path:'/plus/card/card/index'
            },
            {
                key: 'category',
                value: '分类管理',
                path:'/plus/card/category/index'
            },
            {
                key: 'code',
                value: '提货码管理',
                path:'/plus/card/code/index'
            },
            {
                key: 'order',
                value: '提货订单',
                path:'/plus/card/order/index'
            },
            {
                key: 'setting',
                value: '卡券设置',
                path:'/plus/card/setting/index'
            }
        ],
        /*权限筛选后的数据*/
        tabList:[],
      };
    },
    created() {

      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res =>
      {
          this.activeName = res;
      });

      //发送类别切换
      let params = {
          active: this.activeName,
          list: this.tabList,
          tab_type: 'card'
      }
      bus.$emit('tabData', params);

    },
    beforeDestroy () {
        //发送类别切换
        bus.$emit('tabData', {active: null, tab_type:'card', list: []});
        bus.$off('activeValue');
    },
    methods: {

      /*权限过滤*/
      authFilter(){
        let list=[];
        for(let i=0;i<this.sourceList.length;i++){
          let item=this.sourceList[i];
          if(this.$filter.isAuth(item.path)){
            list.push(item);
          }
        }
        return list;
      },

    }
  };
</script>

<style>
  .operation-wrap {
    height: 124px;
    border-radius: 8px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 30px 30px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: hidden;
    background: #909399;
    background-size: 100% 100%;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/card/event.vue